import { inMemoryDataRepository } from "@/be/data/repositories";
import { SAMPLE_DATA } from "@/be/data/sample-data";
import { IdGenerator} from "@/fx/twitter-snowflake";
import { database } from "@/be/adapters/database";
import { queries } from "@/be/queries";
import { commands } from "./commands";
import { environment } from "./environment";
import { context } from "./context";
import { files } from "./files";
import { configuration } from "@/be/configuration/configuration";

export const SERVICES = async () => {

  const idGenerator = new IdGenerator({
    machineId: 0n,
  });
  const idGeneratorWrapped = {
    nextId: async () => {
      const maxAttempts = 10;

      for (let i = 0; i < maxAttempts; i++) {
        const candidate = idGenerator.nextId();

        const id = await DB.tryReserveId({ id: candidate });

        if (candidate.toString() === id) {
          return candidate;
        }
      }
      throw new Error(`Could not generate a unique ID after ${maxAttempts} attempts.`);
    }
  };

  const dataGenerator = new SAMPLE_DATA.DataGenerator();

  type EnvParams = {
    DB_USER:     string,
    DB_PASSWORD: string,
    DB_SERVER:   string,
    DB_PORT:     string,
    DB_NAME:     string,
  }
  const envParams: EnvParams = process.env;

  const dbParams = {
    host:     process.env.DB_SERVER,
    port:     parseInt(process.env.DB_PORT, 10),
    user:     envParams.DB_USER,
    password: envParams.DB_PASSWORD,
    database: process.env.DB_NAME,
  }

  const ID   = idGeneratorWrapped;
  const DB   = await database({ params: dbParams });
  const Q    = await queries ({ DB               });
  const CMD  = await commands({ DB               });
  const ENV  = await environment();
  const CTX  = await context({ Q });
  const F    = await files();
  const DATA = await inMemoryDataRepository({ CTX, dataGenerator });
  const CFG  = await configuration({ CTX });

  function useIdGenerator() { return ID;   }

  return { ID, DB, Q, CMD, ENV, CTX, F, DATA, CFG, useIdGenerator };
}
